import { Container, Stack, Typography, Button, Card, TableContainer, Table, TableBody, TableRow, TableCell, Checkbox, Paper, TablePagination, Snackbar, Alert, Box, Modal } from "@mui/material";
import { useState, ChangeEvent, useEffect } from "react";
import { useSelector } from "react-redux";
import AuthService from "../../../services/api/auth.service";
import ArrayListToolbar from "../../../components/mui/array_manager/ArrayListToolbar";
import ArrayListHead from "../../../components/mui/array_manager/ArrayListHead";
import { applySortFilterOther, getComparator } from "../../../utils/array-user-list";
import { IDataBooking } from "../../../models/entities/IDataBooking";
import Scrollbar from "../../../components/mui/scrollbar/Scrollbar";
import MockDataBooking from "../../../mock/booking.mock";
import BookingService from "../../../services/api/booking.service";
import { saveAs } from "file-saver";
import { Controller, useForm } from "react-hook-form";
import { IDataBookingPost } from "../../../models/entities/IDataBookingPost";
import { useNavigate } from "react-router-dom";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "transparent",
  border: "2px solid #000",
};



const BookingAdmin = () => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    reset
  } = useForm<IDataBookingPost>();
  const lang = useSelector((state: any) => state.langReducer);
  const navigate = useNavigate();
  const TABLE_HEAD = [
    { id: "id", label: "Id", alignRight: false },
    { id: "name", label: lang === "FR" ? "Nom" : "Name", alignRight: false },
    { id: "phone", label: lang === "FR" ? "Téléphone" : "Phone", alignRight: false },
    { id: "email", label: lang === "FR" ? "Email" : "Email", alignRight: false },
    { id: "nbPerson", label: lang === "FR" ? "Nombre de personnes" : "Number Of personnes", alignRight: false },
    { id: "hour", label: lang === "FR" ? "Heure" : "Name", alignRight: false },
    { id: "date", label: lang === "FR" ? "Date" : "Date", alignRight: false },
    { id: "" },
  ];

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState<any>("asc");

  const [selected, setSelected] = useState<Array<string>>([]);

  const [orderBy, setOrderBy] = useState<any>("name");

  const [filterName, setFilterName] = useState("");

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [booking, setBooking] = useState<Array<IDataBooking>>(MockDataBooking);

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - booking.length) : 0;

  const filteredBooking = applySortFilterOther(booking, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredBooking.length && !!filterName;

  const [openFailed, setOpenFailed] = useState(false);
  const [openCreated, setOpenCreated] = useState(false);
  const [message, setMessage] = useState("");
  const [token, setToken] = useState<any>("");
  const [open, setOpen] = useState(false);
  const handleOpenModal = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);
  const [unavailableTimes, setUnavailableTimes] = useState<string[]>([]);
  

  const handleRequestSort = (event: ChangeEvent<HTMLInputElement>, property: any) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds: string[] = booking.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event: ChangeEvent<HTMLInputElement>, name: string) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event: ChangeEvent<HTMLInputElement>) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const handleCloseSnackbar = (event: any, reason: any) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenFailed(false);
  };

  const handleExportFile = () => {
    console.log("Export File")
    const headers = "ID,Nom,Téléphone,Email,Nombre de personnes,Heure,Date\n";
    const rows = booking.map(b => `${b.id},${b.email},${b.phone},${b.name},${b.nbPerson},${extractDateOrTime(b.date,false)},${extractDateOrTime(b.date,true)}`).join("\n");
    const csvContent = headers + rows;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "bookings.csv");
  }
  
  const navigateToDAYLOCK = () => {
    navigate("/daylock")
  }

  function extractDateOrTime(dateTimeString: string, getDate: boolean): string {
    const dateTime = new Date(dateTimeString);

    // Si on veut la date uniquement
    if (getDate) {
      const year = dateTime.getFullYear();
      const month = String(dateTime.getMonth() + 1).padStart(2, "0"); // Mois commence à 0, donc on ajoute 1
      const day = String(dateTime.getDate()).padStart(2, "0");
      return `${day}-${month}-${year}`;
    }
    
    // Si on veut l'heure uniquement
    else {
      const hours = String(dateTime.getHours()).padStart(2, "0");
      const minutes = String(dateTime.getMinutes()).padStart(2, "0");
      const seconds = String(dateTime.getSeconds()).padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    }
  }


  const onSubmit = handleSubmit((data: IDataBookingPost) => {
    console.log(data)
    const dateTime = `${data.date}T${data.hour}:00`;
    const dataValuePush : IDataBookingPost = {
      name: data.name,
      email: data.email,
      date: dateTime,
      nbPerson: Number(data.nbPerson),
      phone: data.phone,
      hour: ""
    }
    console.log("Created", dataValuePush)
    BookingService.post(dataValuePush).then((r) => {
      console.log(r.data)
      if(r.status == 201){
        BookingService.getAllBooking(token).then((r) => {
          setBooking(r.data)
          reset();
        }).catch(e => console.log(e))
      }
    }).catch((r) => console.log(r))
  });


  useEffect(() => {
    if (AuthService.getUserConnected() != "" || AuthService.getUserConnected() != null) {
      setToken(AuthService.getUserConnected());
      BookingService.getAllBooking(token).then((r) => {
        setBooking(r.data)
      }).catch(e => console.log(e))
    } 
  }, [token]);
  const handleTimeFocus = () => {
    setUnavailableTimes(availableTimes);
  };


  const availableTimes = [
    "12:00", "12:30", "13:00", "13:30", "14:00", "14:30", 
    "19:00", "19:30", "20:00", "20:30", "21:00", "21:30"
  ];

  return (
    <>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="component-modal-event">
            <form onSubmit={onSubmit} className="container-form-event">
              <label htmlFor="name">Nom de la personne</label>
              <input
                className="input-form"
                {...register("name", { required: "Le titre est obligatoire" })}
                placeholder={"name"}
                type="text"
                id="name"
              />
              <label htmlFor="phone">Téléphone</label>
              <input
                className="input-form"
                {...register("phone", { required: "Le téléphone est obligatoire" })}
                placeholder={"Téléphone"}
                type="text"
                id="phone"
              />
              <label htmlFor="email">Email</label>
              <input
                className="input-form"
                {...register("email", { required: "Le email est obligatoire" })}
                placeholder={"email"}
                type="email"
                id="email"
              />
              <label htmlFor="date">Date</label>
              <input
                className="input-form"
                {...register("date", { required: "La date est obligatoire" })}
                placeholder={"date"}
                type="date"
                id="date"
              />
              <label htmlFor="hour">Heure</label>
              <select id="hour"  {...register("hour", { required: "Le titre est obligatoire" })} onFocus={handleTimeFocus} required>
                {availableTimes.map((hour) => (
                  <option key={hour} value={hour}>
                    {hour}
                  </option>
                ))}
              </select>
              <label htmlFor="numberPerson">Nombre de personnes</label>
              <select id="numberPerson" {...register("nbPerson", { required: "Le titre est obligatoire" })}>
                {[...Array(6)].map((_, i) => (
                  <option key={i + 1} value={i + 1}>{i + 1}</option>
                ))}
              </select>
              <button type="submit">Ajouter la reservation</button>
            </form>
          </div>
        </Box>
      </Modal>
      <div className="view-array">
        <Container sx={{ maxWidth: "100%", padding:0 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Typography variant="h4" gutterBottom>
              {lang === "FR" ? "Manager vos Reservation" : "Booking Manager"}
            </Typography>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
              <Button
                variant="contained"
                onClick={() => navigateToDAYLOCK()}
                sx={{ background: "rgb(34, 10, 110)",marginRight:2 }}
              >
                {"Day Lock"}
              </Button>
              <Button
                variant="contained"
                onClick={() => handleExportFile()}
                sx={{ background: "rgb(34, 10, 110)",marginRight:2 }}
              >
                {"Export"}
              </Button>
              <Button
                variant="contained"
                onClick={() => handleOpenModal()}
                sx={{ background: "rgb(34, 10, 110)" }}
              >
                {"+"}
              </Button>
            </Stack>
          </Stack>

          <Card>
            <ArrayListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />

            <Scrollbar sx={{ height: "600px",width:"100%" }}>
              <TableContainer sx={{ minWidth: "98%", maxHeight: "100vh", height: "100vh" }}>
                <Table sx={{ height: "600px", width:"100%" }}>
                  <ArrayListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={booking.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredBooking
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row: any, index: number) => {
                        const { id,name ,phone,email,nbPerson,hour,date } = row;
                        const selectedUser = selected.indexOf(id) !== -1;

                        return (
                          <TableRow hover key={index} tabIndex={-1} role="checkbox" selected={selectedUser}>
                            <TableCell padding="checkbox">
                              <Checkbox checked={selectedUser} onChange={(event) => handleClick(event, id)} />
                            </TableCell>

                            <TableCell align="left">{id}</TableCell>
                            <TableCell align="left">{name}</TableCell>
                            <TableCell align="left">{phone}</TableCell>
                            <TableCell align="left">{email}</TableCell>
                            <TableCell align="left">{nbPerson}</TableCell>
                            <TableCell align="left">{extractDateOrTime(date,false)}</TableCell>
                            <TableCell align="left">{extractDateOrTime(date,true)}</TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 100 * emptyRows }}>
                        <TableCell colSpan={7} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              {lang === "FR" ? "Non trouvé" : " Not found"}
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 20, 35]}
              component="div"
              count={booking.length}
            
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
       
      </div>
      <Snackbar open={openCreated} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert severity="success" sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
      <Snackbar open={openFailed} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert severity="error" sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </>
  )
}

export default BookingAdmin;



